import React from 'react';
import { Link } from 'react-router-dom';

function Landing() {
  return (
    <div className="bg-white text-slate-800">
      {/* NAVBAR */}
      <header className="sticky top-0 z-20 bg-white/80 backdrop-blur border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={process.env.PUBLIC_URL + '/branding/ventio-logo.svg'} alt="Ventio" className="h-7" />
            <span className="sr-only">Ventio</span>
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
            <a href="#features" className="text-slate-600 hover:text-slate-900">Características</a>
            <a href="#benefits" className="text-slate-600 hover:text-slate-900">Beneficios</a>
            <a href="#pricing" className="text-slate-600 hover:text-slate-900">Planes</a>
            <a href="#faq" className="text-slate-600 hover:text-slate-900">FAQ</a>
          </nav>
          <div className="flex items-center gap-3">
            <Link to="/login" className="text-sm font-semibold text-slate-700 hover:text-slate-900">Ingresar</Link>
            <Link to="/register-business" className="inline-flex items-center rounded-full bg-indigo-600 text-white text-sm font-semibold px-4 py-2 hover:bg-indigo-700 shadow-sm">Probar gratis</Link>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="relative overflow-hidden pt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-sky-50 to-white" aria-hidden />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 lg:pt-24 pb-12 lg:pb-20">
          <div className="grid lg:grid-cols-2 items-center gap-12">
            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight">
                Vendé más, cobrá más rápido y <span className="text-indigo-600">olvidate del papeleo</span>
              </h1>
              <p className="mt-4 text-lg text-slate-600">
                Sistema completo para tu negocio: punto de venta, facturación AFIP automática, tu propia tienda online y cobros que se confirman solos. Todo simple, todo en un solo lugar.
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <Link to="/register-business" className="inline-flex items-center justify-center rounded-full bg-indigo-600 text-white font-semibold px-6 py-3 hover:bg-indigo-700 shadow">
                  Crear mi cuenta
                </Link>
                <Link to="/login" className="inline-flex items-center justify-center rounded-full border border-slate-300 text-slate-700 font-semibold px-6 py-3 hover:bg-white hover:shadow">
                  Ya tengo cuenta
                </Link>
              </div>
              <div className="mt-4 text-sm text-slate-500">Sin tarjeta de crédito. Cancelá cuando quieras.</div>
            </div>
            <div className="relative">
              <div className="rounded-2xl bg-white ring-1 ring-slate-100 shadow-xl p-4 md:p-6">
                <img src={process.env.PUBLIC_URL + '/website/hero-pos.png'} alt="Panel de Ventas" className="rounded-xl w-full h-auto object-cover" onError={(e) => { e.currentTarget.src = process.env.PUBLIC_URL + '/branding/illustrations/pos-hero.svg'; e.currentTarget.onerror = null; }} />
                <div className="grid grid-cols-3 gap-4 mt-4">
                  <div className="p-3 rounded-lg bg-indigo-50">
                    <div className="text-xs text-indigo-700 font-semibold">Facturación</div>
                    <div className="text-sm text-indigo-900">AFIP/CAE</div>
                  </div>
                  <div className="p-3 rounded-lg bg-sky-50">
                    <div className="text-xs text-sky-700 font-semibold">Stock</div>
                    <div className="text-sm text-sky-900">Alertas</div>
                  </div>
                  <div className="p-3 rounded-lg bg-emerald-50">
                    <div className="text-xs text-emerald-700 font-semibold">Caja</div>
                    <div className="text-sm text-emerald-900">Arqueo</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFICIOS PRINCIPALES */}
      <section id="benefits" className="py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900">
              ¿Por qué elegir Ventio?
            </h2>
            <p className="mt-3 text-slate-600 max-w-2xl mx-auto">
              Diseñado para que puedas enfocarte en vender, no en administrar sistemas complicados
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-600 text-3xl mb-4">
                ✅
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                Cobros que se confirman solos
              </h3>
              <p className="text-slate-600 leading-relaxed">
                Ya no tenés que estar revisando el banco o preguntando "¿me pagaste?". El sistema detecta automáticamente las transferencias y los pagos de Mercado Pago. Vos solo mirás las ventas confirmadas.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-indigo-100 text-indigo-600 text-3xl mb-4">
                🌐
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                Vendé mientras dormís
              </h3>
              <p className="text-slate-600 leading-relaxed">
                Tu tienda online funciona 24/7. Los clientes ven tus productos, eligen, pagan y vos recibís el pedido confirmado. Todo sin que tengas que estar presente. El stock se actualiza solo.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 text-3xl mb-4">
                📄
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                Facturación sin dolores de cabeza
              </h3>
              <p className="text-slate-600 leading-relaxed">
                Olvidate de entrar a AFIP manualmente. El sistema genera las facturas electrónicas automáticamente, las envía al cliente y te da los reportes listos para tu contador. Un click y listo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TIENDA ONLINE HIGHLIGHT */}
      <section className="py-16 lg:py-24 bg-gradient-to-b from-white to-indigo-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-sky-500 rounded-2xl blur opacity-25"></div>
                <div className="relative rounded-2xl bg-white ring-1 ring-slate-200 shadow-2xl overflow-hidden">
                  <img
                    src={process.env.PUBLIC_URL + '/website/assets/img/public-shop-mockup.png'}
                    alt="Tienda Online Propia - Mockup Móvil"
                    className="w-full h-auto object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent flex items-bottom p-6">
                    <div className="mt-auto">
                      <div className="bg-white/20 backdrop-blur-md rounded-lg p-3 border border-white/30">
                        <p className="text-white font-bold text-sm">Tu tienda, tu marca, tus reglas.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <span className="inline-flex items-center rounded-full bg-indigo-100 px-3 py-1 text-sm font-medium text-indigo-700 mb-4">
                ¡Nuevo!
              </span>
              <h2 className="text-3xl font-extrabold text-slate-900 leading-tight">
                Vende las 24hs con tu propia <br className="hidden md:block" />
                <span className="text-indigo-600">Tienda Online</span>
              </h2>
              <p className="mt-4 text-lg text-slate-600">
                No dependas solo de tu mostrador. Ventio te da una tienda profesional que funciona sola: tus clientes compran, pagan y vos recibís todo confirmado automáticamente.
              </p>
              <ul className="mt-8 space-y-4">
                {[
                  'Catálogo digital que se actualiza solo con tu stock real.',
                  'Pagos automáticos con Mercado Pago - el cliente paga y vos cobrás al instante.',
                  'Verificación automática de transferencias - el sistema detecta cuando te pagan.',
                  'Pedidos por WhatsApp con código de verificación para confirmar.',
                  'Mapa interactivo - tus clientes marcan dónde viven y vos calculás el envío.',
                  'Diseño profesional que se ve perfecto en celulares.'
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="mt-1 flex-shrink-0 h-5 w-5 rounded-full bg-indigo-500 flex items-center justify-center">
                      <svg className="h-3.5 w-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-10">
                <Link to="/register-business" className="text-indigo-600 font-bold hover:text-indigo-700 flex items-center gap-2">
                  Ver demo de la tienda
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CARACTERÍSTICAS */}
      <section id="features" className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 text-center">Todo lo que necesitás para vender más</h2>
          <p className="text-center text-slate-600 mt-3 max-w-2xl mx-auto">
            Herramientas profesionales diseñadas para que puedas enfocarte en tu negocio, no en la tecnología
          </p>
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              ['🏪 Punto de Venta Rápido', 'Cobrá en segundos. Escaneá productos, aplicá descuentos y emití tickets o facturas al instante.'],
              ['🌐 Tu Tienda Online 24/7', 'Vendé mientras dormís. Tu catálogo siempre actualizado con stock en tiempo real, pagos con Mercado Pago y pedidos por WhatsApp.'],
              ['💰 Cobros Automáticos', 'Aceptá pagos con Mercado Pago directamente en tu tienda. Tus clientes pagan y vos recibís la confirmación al instante.'],
              ['✅ Verificación de Transferencias', 'El sistema detecta automáticamente cuando te hacen una transferencia bancaria y confirma el pago sin que tengas que revisar el banco.'],
              ['📦 Integración con Mercado Libre', 'Tus ventas de Mercado Libre se registran automáticamente. Facturá y gestioná todo desde un solo lugar.'],
              ['📍 Envíos Inteligentes', 'Tus clientes eligen su dirección en el mapa, calculás costos de envío por zona y ofrecés retiro en sucursal.'],
              ['📄 Facturación AFIP Automática', 'Emití facturas electrónicas legales en un click. El sistema se conecta con AFIP y genera todo automáticamente.'],
              ['💵 Control de Caja', 'Abrí y cerrá tu caja diaria. El sistema te muestra cuánto vendiste, cuánto deberías tener y detecta diferencias.'],
              ['📊 Stock Siempre Actualizado', 'Cargá productos con código de barras, importá desde Excel y recibí alertas cuando se te esté por acabar algo.'],
              ['📈 Reportes para AFIP', 'Generá tus reportes de IVA Ventas listos para presentar. Exportá a Excel y llevá todo en orden.'],
              ['👥 Múltiples Usuarios', 'Cada empleado con su usuario y permisos. Sabés quién vendió qué y cuándo.'],
              ['☁️ Acceso desde Cualquier Lugar', 'Entrá desde tu casa, el local o donde estés. Todo en la nube, siempre disponible.']
            ].map(([t, d], i) => (
              <div key={i} className="rounded-2xl p-6 ring-1 ring-slate-100 bg-white hover:shadow-lg transition-shadow">
                <h3 className="font-semibold text-slate-900 text-lg mb-2">{t}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GALERÍA con fotos ilustrativas */}
      <section className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl md:text-2xl font-extrabold text-slate-900">Así se ve en acción</h2>
          <p className="text-slate-600 mt-2">Algunas imágenes de referencia del uso en punto de venta y gestión.</p>
          <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { src: 'https://images.unsplash.com/photo-1563103840-d77f60b8f19b?q=80&w=1600&auto=format&fit=crop', alt: 'Mostrador y caja en local minorista' },
              { src: 'https://images.unsplash.com/photo-1554774853-b415df9eeb92?q=80&w=1600&auto=format&fit=crop', alt: 'Cobro con lector y ticket' },
              { src: 'https://images.unsplash.com/photo-1523475496153-3d6cc0f2cbef?q=80&w=1600&auto=format&fit=crop', alt: 'Stock en góndola' },
              { src: 'https://images.unsplash.com/photo-1521336575822-6da63fb45455?q=80&w=1600&auto=format&fit=crop', alt: 'Panadería y mostrador' },
              { src: 'https://images.unsplash.com/photo-1492725764893-90b379c2b6e7?q=80&w=1600&auto=format&fit=crop', alt: 'Atención al cliente en comercio' },
              { src: 'https://images.unsplash.com/photo-1515165562835-c3b8c1b4a3af?q=80&w=1600&auto=format&fit=crop', alt: 'Terminal de cobro en caja' }
            ].map((img, i) => (
              <div key={i} className="relative overflow-hidden rounded-xl ring-1 ring-slate-100 bg-slate-50">
                <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-48 object-cover hover:scale-[1.02] transition-transform duration-500" onError={(e) => { e.currentTarget.style.display = 'none' }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING / CTA */}
      <section id="pricing" className="py-16 lg:py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900">Empezá hoy mismo</h2>
          <p className="mt-3 text-slate-600">Planes simples y claros. Probalo gratis: registrá tu negocio y empezá a facturar.</p>
          <div className="mt-8 inline-flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/register-business" className="inline-flex items-center rounded-full bg-indigo-600 text-white font-semibold px-6 py-3 hover:bg-indigo-700 shadow">
              Crear cuenta gratis
            </Link>
            <Link to="/login" className="inline-flex items-center rounded-full border border-slate-300 text-slate-700 font-semibold px-6 py-3 hover:bg-white hover:shadow">
              Ingresar
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ breve */}
      <section id="faq" className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 text-center">Preguntas frecuentes</h2>
          <div className="mt-8 space-y-6">
            {[
              ['¿Cómo funciona la verificación automática de transferencias?', 'El sistema se conecta con tu banco y detecta cuando te hacen una transferencia. Cuando un cliente paga, el sistema lo confirma automáticamente sin que tengas que revisar tu homebanking.'],
              ['¿Necesito conocimientos técnicos para usar la tienda online?', 'No. La tienda se crea automáticamente con tus productos. Solo configurás tu WhatsApp y Mercado Pago, y ya podés vender. Todo es visual y fácil de usar.'],
              ['¿Cómo cobro con Mercado Pago en mi tienda?', 'Conectás tu cuenta de Mercado Pago una sola vez. Después, cuando un cliente compra, paga directamente con tarjeta o débito y vos recibís el dinero en tu cuenta. Todo automático.'],
              ['¿Necesito clave fiscal para facturar?', 'Sí, para emitir facturas electrónicas AFIP necesitás tener clave fiscal nivel 3 y un punto de venta configurado. Te ayudamos con el proceso.'],
              ['¿Puedo usarlo en varios locales o con varios empleados?', 'Sí. Podés crear usuarios para cada empleado con diferentes permisos. También funciona para múltiples sucursales.'],
              ['¿Qué pasa si tengo un problema? ¿Hay soporte?', 'Tenés soporte por WhatsApp y chat en vivo. Te ayudamos a configurar todo y resolver cualquier duda.'],
              ['¿Puedo cancelar cuando quiera?', 'Sí, no hay permanencia mínima. Cancelás cuando quieras sin penalidades.']
            ].map(([q, a], i) => (
              <div key={i} className="rounded-xl p-5 ring-1 ring-slate-100 bg-white hover:shadow-md transition-shadow">
                <h3 className="font-semibold text-slate-900 text-base">{q}</h3>
                <p className="text-slate-600 mt-2 text-sm leading-relaxed">{a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-10 border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3 text-slate-600">
            <img src={process.env.PUBLIC_URL + '/branding/ventio-favicon.svg'} alt="Ventio" className="h-5" />
            <span className="text-sm">© {new Date().getFullYear()} Ventio · Todos los derechos reservados</span>
          </div>
          <div className="text-sm text-slate-500">
            <Link to="/login" className="hover:text-slate-700">Ingresar</Link>
            <span className="mx-2">·</span>
            <Link to="/register-business" className="hover:text-slate-700">Crear cuenta</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
